import React, { useEffect, useState, useCallback } from "react";
import Head from 'next/head';
import { Button, ConfigProvider, Drawer, Layout, Menu, MenuProps } from "antd";
import { NavigationBar } from "./NavigationBar";
import Link from "next/link";
import { useRouter } from "next/router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
// import { signIn, useSession } from "next-auth/react";
// import { logout } from "@/functions/Logout";
import FloatingButtons from "./common/buttons/FloatingButtons";
import CookieBanner from "./CookieBanner";
import { getLocalStorage } from '../functions/Helper';
// import { GoogleAnalytics } from "./GoogleAnalytics";
import { NavLink } from "./NavLink";
import AnnouncementBar from "./AnnouncementBar";

const { Content, Header, Footer } = Layout;

const sidebarBackgroundColor = '#001529';

const DefaultLayout: React.FC<{
    children: React.ReactNode
}> = ({ children }) => {

    // const { data: session, status } = useSession();
    // const displayUserName = session?.user?.name;
    // const displayPicture = session?.user?.image ?? '';
    const router = useRouter();
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [selected, setSelected] = useState([router.pathname]);
    const [cookieConsent, setCookieConsent] = useState<boolean | null>(true);

    useEffect(() => {
        const storedCookieConsent = getLocalStorage('cookie_consent', null);
        setCookieConsent(storedCookieConsent);
    }, []);

    const updateCookieConsent = useCallback((consent: boolean) => {
        setCookieConsent(consent);
    }, []);

    // function renderAvatar() {
    //     if (status === 'authenticated') {
    //         return (
    //             <div className="flex flex-col items-center">
    //                 <div>
    //                     <img src={displayPicture} alt="" style={{ width: 50 }} className="rounded-full" />
    //                 </div>
    //                 <div className="my-4">
    //                     Halo, {displayUserName}
    //                 </div>
    //             </div>
    //         );
    //     }

    //     return null;
    // }

    // const onLogout = logout;

    function getMenu(): MenuProps['items'] {
        const menu: MenuProps['items'] = [];

        menu.push({
            key: '/',
            label: 'Home',
            onClick: () => {
                setDrawerOpen(false)
                router.push('/')
            }
        });

        menu.push({
            key: '/tentang-kami',
            label: 'About Us',
            onClick: () => {
                setDrawerOpen(false)
                router.push('/tentang-kami')
            }
        });



        menu.push(
            {
                key: '/#program-type',
                label: 'Program',
                onClick: () => {
                    setDrawerOpen(false)
                    // Because when the default layout is pressed, the program will enter the program type section
                    // setTimeout(() => {
                    //     router.push('/#program-type')
                    // }, 500)
                },
                children: [
                    {
                        key: 'LMS',
                        label: 'Learning Management System',
                        onClick: () => {
                            router.push('/lms')
                        }
                    },
                    {
                        key: 'BNSP',
                        label: 'Pelatihan Perusahaan dan Uji BNSP',
                        onClick: () => {
                            router.push('/program/bnsp')
                        }
                    },
                    {
                        key: 'bootcamp',
                        label: 'Bootcamp Terakreditasi Kemnaker',
                        onClick: () => {
                            router.push('/program/bootcamp')
                        }
                    },
                    {
                        key: 'ekstrakulikuler',
                        label: 'Ekstrakulikuler tingkat SD, SMP, SMA',
                        onClick: () => {
                            router.push('/ekskul')
                        }
                    },
                ]
            },
        );

        // menu.push({
        //     key: '/lms',
        //     label: 'LMS',
        //     onClick: () => {
        //         setDrawerOpen(false)
        //         router.push('/lms')
        //     }
        // });

        menu.push({
            key: '/certificate',
            label: 'Certificate',
            onClick: () => {
                setDrawerOpen(false)
                router.push('/certificate')
            }
        });

        menu.push({
            key: '/#testimony',
            label: 'Testimonial',
            onClick: () => {
                setDrawerOpen(false)
                setTimeout(() => {
                    router.push('/#testimony')
                }, 500)
            }
        });

        menu.push({
            key: '/accelist-group',
            label: 'Accelist Group',
            onClick: () => router.push('https://accelist.com/'),
        });

        menu.push({
            key: '/blog',
            label: 'News',
            onClick: () => {
                setDrawerOpen(false)
                router.push('/blog')
            }
        });

        // if (status === 'authenticated') {
        //     menu.push({
        //         key: '/sign-out',
        //         label: `Keluar`,
        //         onClick: () => onLogout()
        //     });
        // } else {
        //     menu.push({
        //         key: '/login',
        //         label: 'Login',
        //         onClick: () => signIn('auth0')
        //     });
        // }

        return menu;
    }


    const [hideAnnouncement, setHideAnnouncement] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [closedByUser, setClosedByUser] = useState(false);

    useEffect(() => {
        setClosedByUser(false);
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 768);
        };

        checkMobile();
        window.addEventListener("resize", checkMobile);

        return () => window.removeEventListener("resize", checkMobile);
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (closedByUser) return;

            // ❗ DESKTOP: announcement selalu tampil
            if (!isMobile) {
                setHideAnnouncement(false);
                return;
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [isMobile, closedByUser]);


    return (
        <ConfigProvider theme={{
            components: {
                Layout: {
                    // Sidebar background color:
                    // https://github.com/ant-design/ant-design/blob/5.0.0/components/layout/style/index.tsx#L101
                    colorBgHeader: sidebarBackgroundColor
                }
            }
        }}>
            <Layout className="min-h-screen relative">
                <Head>
                    <meta key="meta-charset" charSet="utf-8" />
                    <meta key="meta-viewport" name="viewport" content="width=device-width, initial-scale=1" />
                    <link key="favicon" rel="icon" href="/favicon.ico" />
                </Head>
                <Header className="bg-white drop-shadow-lg h-auto sticky top-0 z-50 w-full hidden lg:block">
                    <NavigationBar />

                </Header>

                <Drawer
                    placement="left"
                    open={drawerOpen}
                    onClose={() => setDrawerOpen(false)}
                    closable={false}
                    bodyStyle={{ position: "relative", paddingTop: "3rem" }}
                >
                    <Button
                        onClick={() => setDrawerOpen(false)}
                        className="absolute top-2 left-3 w-8 h-8 flex items-center justify-center font-bold shadow-lg 
                            bg-gray-300 rounded-full text-gray-700 hover:bg-gray-400 hover:text-black text-3xl leading-none"
                    >
                        <span className="relative -top-[3px]">&times;</span>
                    </Button>

                    {/* {renderAvatar()} */}
                    <ConfigProvider theme={{
                        components: {
                            Menu: {
                                // https://github.com/ant-design/ant-design/blob/5.0.0/components/menu/style/theme.tsx#L194
                                colorActiveBarBorderSize: 0
                            }
                        }
                    }}>
                        <Menu mode="inline" items={getMenu()}
                            selectedKeys={selected} onSelect={e => setSelected(e.selectedKeys)} />
                    </ConfigProvider>
                </Drawer>
                <Layout>
                    <div className='sticky top-0 w-full bg-white grid grid-cols-3 lg:hidden xl:hidden 2xl:hidden px-2 py-2 items-center drop-shadow-md z-30'>
                        <div>
                            <Button onClick={() => setDrawerOpen(true)} className="duration-300 bg-accelist-green hover:bg-black border-none">
                                <FontAwesomeIcon icon={faBars} style={{ color: 'white' }} />
                            </Button>
                        </div>
                        <img src="/img/layouting/logo-accelist.png" alt="Logo" />
                    </div>
                    {!closedByUser && (
                        <AnnouncementBar hide={hideAnnouncement} />
                    )}
                    <Content className="bg-white">
                        {children}
                    </Content>
                </Layout>
                <Footer>
                    <div className="container mx-auto flex flex-wrap justify-between text-accelist-font text-sm lg:text-base px-5 pt-6 gap-y-10">
                        {/* Kolom 1: Logo dan Kontak */}
                        <div className="w-full md:w-1/3 lg:w-1/3 space-y-4 text-[#6c7484]">
                            <img src="/img/layouting/logo-accelist.png" alt="Logo" className="w-44 mb-6" />
                            <div className="flex items-start space-x-3 md:pt-6">
                                <img src="/img/layouting/maps-green.svg" alt="Location" className="w-5 h-5 mt-1" />
                                <p>Ruko Bolsena Blok A-19, Curug Sangereng, Kec. Klp. Dua, Kabupaten Tangerang, Banten 15810, Indonesia</p>
                            </div>
                            <div className="flex items-center space-x-3">
                                <img src="/img/layouting/email-green.svg" alt="Email" className="w-5 h-5" />
                                <p>marketing@edu.accelist.com</p>
                            </div>
                            <div className="flex items-center space-x-3">
                                <img src="/img/layouting/telp-green.svg" alt="Phone" className="w-5 h-5" />
                                <p>62 859-5959-5915</p>
                            </div>
                            <div className="flex items-center space-x-3">
                                <img src="/img/layouting/web-green.svg" alt="Website" className="w-5 h-5" />
                                <p>http://www.accelist.com</p>
                            </div>
                        </div>

                        {/* Kolom 2: Main Menu */}
                        <div className="w-full sm:w-1/6 md:w-1/4 lg:w-1/5 space-y-4 md:space-y-6 pl-0 sm:pl-12">
                            <p className="text-accelist-green text-2xl font-bold mb-4">Main Menu</p>
                            <NavLink href="/" className="block mb-2">Home</NavLink>
                            <NavLink href="/tentang-kami" className="block mb-2">About Us</NavLink>
                            <Link href="/#testimony" className="block mb-2 hover:text-accelist-green">Testimony</Link>
                            <NavLink href="/blog" className="block mb-2">News</NavLink>

                        </div>

                        {/* Kolom 3: Program */}
                        <div className="w-full sm:w-1/6 md:w-1/4 lg:w-1/4 space-y-4 md:space-y-6">
                            <p className="text-accelist-green text-2xl font-bold mb-4">Program</p>
                            <NavLink href="/lms" className="block mb-2">Learning Management System</NavLink>
                            {/* <Link href='/program/free-course/introduction-to-IT-programming' className="mb-2 block ">Introduction to IT Programming</Link> */}
                            <NavLink href='/program/bnsp' className="mb-2 block">Pelatihan Perusahaan dan Uji BNSP</NavLink>
                            <NavLink href='/program/bootcamp' className="mb-2 block">Bootcamp Terakreditasi Kemnaker</NavLink>
                            <NavLink href="/ekskul" className="block">Ekstrakulikuler Sekolah</NavLink>
                        </div>

                        {/* Kolom 4: Info */}
                        <div className="w-full md:w-1/4 lg:w-1/6 space-y-4 md:space-y-6">
                            <p className="text-accelist-green text-2xl font-bold mb-4">Informasi</p>
                            {/* <p className="block mb-2">Kebijakan Privasi</p> */}
                            <Link href="/#faq" className="block hover:text-accelist-green">FAQ</Link>
                            <Link href="https://accelist.com" className="block hover:text-accelist-green">Accelist Group</Link>
                        </div>
                    </div>

                    {/* Social Media */}
                    <div className="container mx-auto flex justify-end space-x-3 mt-4">
                        <a href="https://www.youtube.com/@AccelistEdukasiIndonesia" target="_blank" rel="noreferrer">
                            <img src="/img/layouting/youtube.png" alt="YouTube" className="w-10 h-10" />
                        </a>
                        <a href="https://instagram.com/accelistedukasi.indonesia" target="_blank" rel="noreferrer">
                            <img src="/img/layouting/instagram.png" alt="Instagram" className="w-10 h-10" />
                        </a>
                        <a href="https://www.tiktok.com/@accelistedukasiindonesia" target="_blank" rel="noreferrer">
                            <img src="/img/layouting/tiktok.png" alt="TikTok" className="w-10 h-10" />
                        </a>
                        <a href="https://www.facebook.com/profile.php?id=100092659237819" target="_blank" rel="noreferrer">
                            <img src="/img/layouting/facebook.png" alt="Facebook" className="w-10 h-10" />
                        </a>
                        <a href="https://www.linkedin.com/company/accelist-edukasi-indonesia/" target="_blank" rel="noreferrer">
                            <img src="/img/layouting/linkedin.png" alt="LinkedIn" className="w-10 h-10 mr-14" />
                        </a>
                    </div>

                    {/* Copyright */}
                    <div className="border-t mt-4 pt-4 text-center text-sm text-gray-500">
                        Copyright ©2023 Accelist Edukasi Indonesia
                    </div>
                </Footer>
                <div
                    className={`fixed bottom-0 right-0 z-40  ${cookieConsent === null ? 'translate-y-[-70px]' : ''
                        }`}
                >
                    <FloatingButtons />
                </div>
                <CookieBanner updateCookieConsent={updateCookieConsent} />
                {/* <GoogleAnalytics /> */}
            </Layout>
        </ConfigProvider>
    );
}

export const WithDefaultLayout = (page: React.ReactElement) => <DefaultLayout>{page}</DefaultLayout>;